<template>
  <div>
    <div class="flex-fill d-flex flex-column justify-content-center">
      <div class="container-tight py-6">
        <div class="text-center mb-4 mt-4">
          <a href="/"
            ><img
              :src="require('../assets/images/logo-dark.png')"
              height="36"
              alt=""
          /></a>
        </div>
        <form class="card card-md" @submit.prevent="signin">
          <div class="card-body">
            <h2 class="mb-5 text-center">重設密碼</h2>
            <div class="alert alert-danger" v-show="error" role="alert">
              {{ errorMsg }}
            </div>
            <div class="alert alert-success" v-show="success" role="alert">
              {{ successMsg }}
            </div>
            <div class="mb-3">
              <label class="form-label">密碼</label>
              <div class="input-group input-group-flat">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  v-model="password"
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">重複密碼</label>
              <div class="input-group input-group-flat">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  v-model="repeatPassword"
                />
              </div>
            </div>
            <div class="form-footer">
              <button type="submit" class="btn btn-primary w-100">
                重設密碼
              </button>
            </div>
          </div>
        </form>
        <div class="text-center text-muted mt">
          已經有帳號?
          <router-link to="/login">登入</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      token: this.$route.params.token,
      password: "",
      repeatPassword: "",
      errorMsg: "",
      error: false,
      successMsg: "",
      success: false,
    };
  },
  methods: {
    async signin() {
      if (
        this.password !== this.repeatPassword ||
        this.password == "" ||
        this.password.length < 6
      ) {
        this.error = true;
        this.errorMsg = "錯誤";
      } else {
        const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/resetPassword`;
        try {
          const response = await this.$http.patch(api, {
            newPassword: this.password,
            token: this.token,
          });
          if (response.data.status == "success") {
            this.error = false;
            this.success = true;
            this.successMsg = "密碼修改完成";
            this.password = "";
            this.repeatPassword = "";
          } else {
            this.success = false;
            this.error = true;
            this.errorMsg = "錯誤";
          }
        } catch (err) {
          this.success = false;
          this.error = true;
          this.errorMsg = "錯誤";
        }
      }
    },
  },
};
</script>

<style scoped>
.page {
  padding-top: 100px;
}
</style>
